import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, HStack, Heading, Text, VStack, useDisclose } from "native-base";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import styles from "./styles.module.css";
import colors from "../../constants/colors";

function Holder(props) {
  const { isLoading, holder, setHolder, disabled } = props;
  const { isOpen, onToggle, onClose } = useDisclose();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [contactMedium, setContactMedium] = useState("");

  useEffect(() => {
    if (holder) {
      setFirstName(holder?.firstName || "");
      setLastName(holder?.lastName || "");
      setEmail(holder?.email || "");
      setPhone(holder?.phone || "");
      setContactMedium(holder?.contactMedium || "");
    }
  }, [holder, isOpen]);

  if (isLoading) {
    return <Box height={8} />;
  }

  return (
    <HStack flex={1} justifyContent="flex-end" position="relative">
      <button onClick={onToggle}>
        <HStack
          height={8}
          space={3}
          backgroundColor={colors.white}
          paddingX={2}
          paddingY={1}>
          <Text>
            {holder ? "El viaje es para un tercero" : "El viaje es propio"}
          </Text>
          {isOpen ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
        </HStack>
      </button>
      {isOpen && (
        <form
          className={styles.form}
          onSubmit={(e) => {
            e.preventDefault();
            setHolder({
              ...holder,
              firstName,
              lastName,
              email,
              phone,
              contactMedium,
            });
            onClose();
          }}>
          <VStack
            backgroundColor={colors.white}
            padding={3}
            shadow={1}
            space={3}>
            <Heading color={colors.secondary} fontSize="xl">
              Datos del cliente
            </Heading>
            <input
              placeholder="Nombre"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              readOnly={disabled}
            />
            <input
              placeholder="Apellido"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              readOnly={disabled}
            />
            <input
              type="email"
              placeholder="Correo electrónico"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              readOnly={disabled}
            />
            <PhoneInput
              labels={es}
              defaultCountry="MX"
              disabled={isLoading}
              value={phone}
              onChange={setPhone}
              readOnly={disabled}
              required
            />
            <select
              value={contactMedium}
              onChange={(e) => setContactMedium(e.target.value)}
              required
              disabled={disabled}>
              <option value="" disabled>
                Selecciona el medio de contacto
              </option>
              <option value="phone">Teléfono</option>
              <option value="email">Correo electrónico</option>
            </select>
            {!disabled && (
              <button>
                <HStack
                  backgroundColor={colors.primary}
                  justifyContent="center"
                  paddingY={2}
                  borderRadius={5}>
                  <Text color={colors.white}>Guardar</Text>
                </HStack>
              </button>
            )}
          </VStack>
        </form>
      )}
    </HStack>
  );
}

Holder.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  holder: PropTypes.any,
  setHolder: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Holder.defaultProps = {
  holder: {},
  disabled: false,
};

export default React.memo(Holder);
